import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './core/components/header/header.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { AccessDeniedComponent } from './core/components/access-denied/access-denied.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { SpinnerConfig, ToastrConstant } from './core/constants/project.constant';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthorizeService } from './core/guards/authorize/authorize.guard';
import { ErrorInterceptor } from './core/interceptors/error/error.service';
import { SpinnerComponent } from './core/components/spinner/spinner.component';
import { NgxUiLoaderHttpModule, NgxUiLoaderModule, NgxUiLoaderRouterModule } from 'ngx-ui-loader';
import { CallbackComponent } from './core/components/callback/callback.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    AccessDeniedComponent,
    SpinnerComponent,
    CallbackComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    ToastrModule.forRoot(ToastrConstant),
    NgxUiLoaderModule.forRoot(SpinnerConfig),
    NgxUiLoaderHttpModule.forRoot(
      {
        showForeground: true
      }), // This will show the loader while making http calls
    NgxUiLoaderRouterModule, // This will show the loader while routing
    AuthModule.forRoot({
      domain: environment.auth.domain,
      clientId: environment.auth.clientId,
      authorizationParams: {
        audience: environment.auth.audience,
        redirect_uri: environment.auth.redirectUri,
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: environment.auth.useRefreshTokens,
      useRefreshTokensFallback: false,
      httpInterceptor: {
        allowedList: [
          `${environment.urlMapping.AAT_IM_API}*`
        ]
      }
    })
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    AuthorizeService,
    // ErrorInterceptor is registered before AuthHttpInterceptor so that on responses
    // (which execute in reverse registration order), ErrorInterceptor runs last and
    // can catch Auth0 SDK token errors thrown by AuthHttpInterceptor.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true
    },
    provideAnimationsAsync()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
